import { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { toast } from "sonner";
import { filterContent } from "./contentModel";

export const useContentLibrary = () => {
  const { userId } = useParams();
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("all");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;
    axios.get(`${API}/content/${userId}`)
      .then((res) => setItems(res.data || []))
      .catch((err) => { console.error("Error fetching content:", err); setItems([]); })
      .finally(() => setLoading(false));
  }, [userId]);

  const filtered = useMemo(() => filterContent(items, query, category), [items, query, category]);

  const personalize = (item) => toast.success(`Personalizing "${item.title}" for your selected account...`);
  const create = () => toast.info("Content creation feature coming soon. Save leads from Hunt mode to generate personalized content!");

  return { query, setQuery, category, setCategory, filtered, loading, personalize, create };
};
